<template>
<div>
      <template v-if="standaloneActiveField">
          <input type="hidden" name="definition" :value="JSON.stringify(activeField)">
      </template>
      <b-form>
      <template v-if="activeField && Object.keys(activeField).length">
        <b-row>
          <b-col cols="12">
            <b-form-group label="Label Name" v-show="activeField.hasOwnProperty('label')">
              <b-form-textarea :rows="4" v-model="activeField.label" :placeholder="activeField.isPlaceholderVisible ? activeField.placeholder : ''"></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>

        <b-form-group label="Height in px" v-show="activeField.hasOwnProperty('fieldType') && activeField['fieldType'] == 'Carousel'">
          <b-form-input  v-model="activeField.controlHeight" type="number" ></b-form-input>
        </b-form-group>

        <!-- Show only when 'isPlacehodlerVisible' key exist -->
        <b-form-group label="Placeholder" v-show="activeField.hasOwnProperty('isPlaceholderVisible')">
          <b-row>
            <b-col cols="3">
              <b-form-checkbox v-model="activeField.isPlaceholderVisible" class="mt-2" switch></b-form-checkbox>
            </b-col>
            <b-col cols="9">
              <b-form-input
              :disabled="!activeField.isPlaceholderVisible"
              v-model="activeField.placeholder">{{activeField.placeholder}}</b-form-input>
            </b-col>
          </b-row>
        </b-form-group>

        <b-row>
          <b-col cols="6">
            <b-form-group label="Required field?" v-show="activeField.hasOwnProperty('isRequired')">
              <b-form-checkbox v-model="activeField.isRequired" class="mt-2" switch></b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label="Layout - Max 12" v-show="activeField.hasOwnProperty('span')">
              <b-form-input  v-model="activeField.span" :min="1" :max="12" controls-position="right" type="number">{{activeField.label}}</b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-form-group label="Button text" v-show="activeField.hasOwnProperty('buttonText')">
          <b-form-input v-model="activeField.buttonText">{{activeField.buttonText}}</b-form-input>
        </b-form-group>

          <b-form-group label="Tooltip">
              <b-row>
                  <b-col cols="3" :key='`group_isTooltipVisible_${activeField.id}`'>
                      <b-form-checkbox :key='`isTooltipVisible_${activeField.id}`' v-model="activeField.isTooltipVisible" class="mt-2" switch></b-form-checkbox>
                  </b-col>
                  <b-col cols="9">
                      <b-form-input
                          :disabled="!activeField.isTooltipVisible"
                          v-model="activeField.tooltipText">{{activeField.tooltipText}}</b-form-input>
                  </b-col>
              </b-row>
          </b-form-group>

          <b-form-group label="Helpblock" v-show="activeField.hasOwnProperty('isHelpBlockVisible')">
              <b-row>
                  <b-col cols="3" :key='`group_isHelpBlockVisible_${activeField.id}`'>
                      <b-form-checkbox :key='`isHelpBlockVisible_${activeField.id}`' v-model="activeField.isHelpBlockVisible" class="mt-2" switch></b-form-checkbox>
                  </b-col>
                  <b-col cols="9">
                      <b-form-input
                          :disabled="!activeField.isHelpBlockVisible"
                          v-model="activeField.helpBlockText">{{activeField.helpBlockText}}</b-form-input>
                  </b-col>
              </b-row>
          </b-form-group>

          <b-row>
            <b-col cols="6">
              <b-form-group label="Active Text" v-show="activeField.hasOwnProperty('activeText')">
                <b-form-input v-model="activeField.activeText">{{activeField.activeText}}</b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Inactive Text" v-show="activeField.hasOwnProperty('inActiveText')">
                <b-form-input v-model="activeField.inActiveText">{{activeField.inActiveText}}</b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

        <b-row>
          <b-col cols="12">
            <b-form-group label="Items" v-show="activeField.hasOwnProperty('items')">
              <b-row v-for="(item, index) in activeField.items" :key="index">
                <b-col cols="10">
                  <b-form-input class="properties__optionslist" v-model="item.url">{{item.url}}</b-form-input>
                </b-col>
                <b-col cols="2">
                  <b-button size="sm" variant="outline-danger"  @click="deleteOption(activeField.items, index)" v-show="activeField.items.length > 1">
                    <b-icon icon="trash" class="rounded p-0"></b-icon>
                  </b-button>
                </b-col>
              </b-row>
              <a size="sm" href="#" class="text-success" @click.prevent="addItem(activeField.items)">Add more items</a>
            </b-form-group>
          </b-col>
        </b-row>

        <b-form-group label="Data source from existing list" v-show="activeField.hasOwnProperty('isFromFormList') && isMultiple(activeField.fieldType)">
          <b-row>
            <b-col cols="3">
              <b-form-checkbox v-model="activeField.isFromFormList" class="mt-2" switch></b-form-checkbox>
            </b-col>
            <b-col cols="9" v-show="activeField.isFromFormList">
              <select v-model="activeField.formListTag">
                <option v-for="list in lists">{{ list }}</option>
              </select>
            </b-col>
          </b-row>
        </b-form-group>

        <b-form-group label="Validator from existing list" v-show="activeField.hasOwnProperty('isFromValidatorModel') && isMultiple(activeField.fieldType)">
          <b-row>
            <b-col cols="3">
              <b-form-checkbox v-model="activeField.isFromValidatorModel" class="mt-2" switch></b-form-checkbox>
            </b-col>
            <b-col cols="9" v-show="activeField.isFromValidatorModel">
              <select v-model="activeField.validatorModelTag">
                <option v-for="validator in validators">{{ validator }}</option>
              </select>
            </b-col>
          </b-row>
        </b-form-group>

        <b-form-group label="Accession Code Validation" v-show="activeField.hasOwnProperty('hasAccessionCodeValidation') && activeField.tagname === 'ACCESSION'">
          <b-form-checkbox v-model="activeField.hasAccessionCodeValidation" class="mt-2" switch></b-form-checkbox>
        </b-form-group>

        <b-row v-show="activeField.tagname === 'REFNUM'">
          <b-col cols="6">
            <b-form-group label="BondWatch Instruction Validation" v-show="activeField.hasOwnProperty('hasBondWatchInstructionValidation')">
              <b-form-checkbox v-model="activeField.hasBondWatchInstructionValidation" class="mt-2" switch></b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col cols="6" v-if="activeField.hasBondWatchInstructionValidation">
            <b-form-group label="BondWatch Valdiation is Blocking" v-show="activeField.hasOwnProperty('bondWatchInstructionValidationIsBlocking') && activeField.fieldType !== 'Flag'">
              <b-form-checkbox v-model="activeField.bondWatchInstructionValidationIsBlocking" class="mt-2" switch></b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <!-- isFromFormList -->
            <!-- formListTag -->
            <b-form-group label="Options" v-if="!activeField.isFromFormList && activeField.options && activeField.fieldType !== 'Flag'">
              <b-row>
                <b-col cols="5">Label</b-col>
                <b-col cols="5">Value</b-col>
                <b-col cols="2">&nbsp;</b-col>
              </b-row>
              <b-row v-for="(item, index) in activeField.options" :key="index" >
                <b-col cols="5">
                  <b-form-input v-model="item.optionLabel">{{item.optionLabel}}</b-form-input>
                </b-col>
                <b-col cols="5">
                  <b-form-input v-model="item.optionValue">{{item.optionValue}}</b-form-input>
                </b-col>
                <b-col cols="2">
                  <b-button size="sm" variant="outline-danger" @click="deleteOption(activeField.options, index)" v-show="activeField.options.length > 1">
                    <b-icon icon="trash" class="rounded p-0"></b-icon>
                  </b-button>
                </b-col>
              </b-row>
              <a size="sm" href="#" class="text-success" @click="addOption(activeField.options)">Add more options</a>
            </b-form-group>
          </b-col>
        </b-row>


        <b-form-group label="Html Content" v-show="activeField.hasOwnProperty('htmlContent')">
            <b-form-textarea :rows="10" v-model="activeField.htmlContent" :placeholder="activeField.isPlaceholderVisible ? activeField.placeholder : ''"></b-form-textarea>
        </b-form-group>

        <b-button id="advanced-options-btn" v-show="activeField.hasOwnProperty('advancedOptions') && activeField.advancedOptions" @click="toggleAdvancedModal" style="width: 100%;" variant="success">
          Advanced Options
        </b-button>
        <b-modal ok-only centered :title="`Advanced Options for ${activeField.label}`" ref="OptionsForm">
          <b-form>
            <text-input-advanced-props v-if="activeField.fieldType === 'TextInput'"></text-input-advanced-props>
            <rating-advanced-props v-if="activeField.fieldType === 'Rating'"></rating-advanced-props>
            <number-input-advanced-props v-if="activeField.fieldType === 'NumberInput'"></number-input-advanced-props>

            <select-list-advanced-props v-if="activeField.fieldType === 'SelectList'"></select-list-advanced-props>
          </b-form>
          <div slot="footer" class="dialog-footer">
            <b-button variant="primary" @click.prevent="toggleAdvancedModal">Confirm</b-button>
          </div>
        </b-modal>
        <br>
        <br>
    </template>
    <template v-if="!standaloneActiveField">
      <b-button id="advanced-options-btn" @click="toggleConditionsModal" style="width: 100%;" variant="warning">
        Conditions
      </b-button>
      <b-modal ok-only centered size="xl" :title="`Conditions for ${(editingSection ? ('Section ' + activeSection.title) : activeField.label)}`" ref="ConditionsForm">
        <b-form>
          <conditioning-fields />
        </b-form>
        <div slot="footer" class="dialog-footer">
          <b-button variant="primary" @click.prevent="toggleConditionsModal">Confirm</b-button>
        </div>
      </b-modal>
    </template>
    <strong v-if="activeSection && activeSection.tagName"><em>TagName: </em><strong>{{ activeSection.tagName }}</strong></strong>

  </b-form>
</div>
</template>

<script>
import RatingAdvancedProps from './RatingAdvancedProps'
import ConditioningFields from '../ConditioningFields'
import TextInputAdvancedProps from './TextInputAdvancedProps.vue'
import NumberInputAdvancedProps from './NumberInputAdvancedProps.vue'
import SelectListAdvancedProps from './SelectListAdvancedProps.vue'

export default {
  name: 'Properties',
  props: ['standaloneActiveField', 'availableLists', 'availableValidators'],
  components: {
    RatingAdvancedProps,
    ConditioningFields,
    TextInputAdvancedProps,
    NumberInputAdvancedProps,
    SelectListAdvancedProps
  },
  store: ['activeField', 'lists', 'validators', 'conditioners', 'activeSection', 'editingSection'], // Get the form data from Home
  data() {
    return {
      multiples: [
        'Flag',
        'SelectList',
        'RadioButton',
        'CheckBox',
      ],
      labelPosition: 'top',
      fieldProperties: {},
      rules: {},
      advancedPropsVisible: false,
      dialogRules: {
        dataUrl: [
           { required: true, message: 'Please input url', trigger: 'change' }
        ]
      }
    }
  },
  mounted() {
    if(this.standaloneActiveField) {
      this.activeField = this.standaloneActiveField
    }

    if(this.availableLists) {
      this.lists = this.availableLists
    }

    if(this.availableValidators) {
      this.validators = this.availableValidators
    }
    // console.log("activeField ->", this.activeField)
    // console.log("activeField.hasOwnProperty('span') ->", this.activeField.hasOwnProperty('span'))
  },
  methods: {
    isMultiple(fieldType) {
      return this.multiples.indexOf(fieldType) !== -1
    },

    deleteOption(option, index) {
      this.$delete(option, index)
    },
    addOption(option) {
      let count = option.length + 1;
      option.push({
        optionLabel: "Option Label " + count,
        optionValue: "Option " + count
      })
    },
    addItem(item) {
      item.push({
        url: ''
      });
    },
    deleteColumn(column, index, prop) {
      this.$delete(column, index)
      this.activeField.tableDatas.forEach(function(ele) {
        delete ele[prop];
      })
    },
    addColumn(tableColumns) {
      tableColumns.push({
        prop: '',
        label: '',
        width: 180
      });
    },
    columnWidth(value) {
      if (value && isNaN(value)) {
        this.$message.error('Column width should be a number!');
      }
    },
    toggleAdvancedModal() {
      this.$refs['OptionsForm'].toggle('#advanced-options-btn')
    },
    toggleConditionsModal() {
      this.$refs['ConditionsForm'].toggle('#conditions-btn')
    },
  }
}
</script>

<style lang="scss">
.properties__optionslist {
    margin-bottom: 5px;
    list-style: none;
    list-style-type: none;
}
.properties__optionsul {
    padding: 0;
}

.modal-backdrop {
  opacity: 0.6!important;
}
</style>
